module.exports = __webpack_public_path__ + "static/img/qianggou.a7bd0b94.png";